// extracted by mini-css-extract-plugin
export default {"wrapper":"Hl-z","response":"Il-z","error":"Jl-z","disabled":"Kl-z","buttons":"Ll-z","feedbackQuestionSection":"Ml-z","yesNoWrapper":"Nl-z"};